import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadVendorLists = async () => {
  try {
    const response = await Axios.get('vendorpricelists');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadVendorList = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/vendorpricelists');
        const requestData = await response.data;
        return {...requestData, vendorlist: {}};
        
      default:
        const respnse = await Axios.get('vendorpricelists/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useContactAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('vendorpricelists', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('vendorlists_created', responseData.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('vendorpricelists/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('vendorlists_created', responseData.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useContactAPI;


